<template>
  <div class="container">
    <div class="bb_fx_tg" @click="bb_ang()" v-show="agencyinvitestatus==1">
      <span>推广&nbsp;</span>
      <label></label>
    </div>
    <div class="bb_fx_bf" @click="bb_invite()" v-show="agencyinvitestatus==1">
      <span>&nbsp;邀请</span>
      <label></label>
    </div>
    <div class="uinfo" v-show="loaded">
      <img class="uinfo_bg" src="../../assets/images/base/mybg.png" />
      <img class="userinfo_logotxtb" src="../../assets/images/base/bowenvars.png" />
      <div class="userinfo_logotxt" v-if="!nologin">
        <img class="userinfo_logotxti" :src="userinfo.avatar" />
        <div class="userinfo_logotxt1">
          {{userinfo.name}}
          <img v-show="userinfo.sex==1||userinfo.sex=='1'" class="userinfo_logotxt1_female" src="../../assets/images/fl20210204/female.png" />
          <img v-show="userinfo.sex==2||userinfo.sex=='2'" class="userinfo_logotxt1_female" src="../../assets/images/fl20210204/woman.png">
        </div>
        <div class="userinfo_logotxt2">{{userinfo.mobile}}</div>
      </div>
      <div class="userinfo_logotxt" v-else>
        <img class="userinfo_logotxti" @click="tologin()" src="../../assets/images/base/nologin.png" />
        <div class="userinfo_mologin" @click="tologin()">登录/注册</div>
      </div>


      <myPanelFunctionOrder @toOrder="toOrder"></myPanelFunctionOrder>
      <!-- <div class="myorder uinfo_order">
        <div class="myorder__box">
          <div class="myorder__box_title">
            <a @click="toOrder(0)">全部预约</a>
            我的预约
          </div>
          <ul>
            <li>
              <div @click="toOrder(1)" class="box">
                <div class="icon i3"></div>
                <p>待使用</p>
              </div>
            </li>
            <li>
              <div @click="toOrder(2)" class="box">
                <div class="icon i2"></div>
                <p>已退订</p>
              </div>
            </li>
            <li>
              <div @click="toOrder(3)" class="box">
                <div class="icon i1"></div>
                <p>已完成</p>
              </div>
            </li>
          </ul>
        </div>
      </div> -->

    </div>

    <myPanelFunctionLink @toMyDetail="toMyDetail" @qimoChatClickyun="qimoChatClickyun" :loaded="loaded"></myPanelFunctionLink>
    <!-- <ul class="link link_myorder" v-show="loaded">
      <li><a class="box" @click="toMyDetail('myCard')">我的企业卡</a></li>
      <li><a class="box" @click="toMyDetail('mycoupon')">我的优惠券</a></li>
      <li><a class="box" @click="qimoChatClickyun()">意见反馈</a></li>
    </ul> -->

    <div v-show="loaded" class="keftelout" @click="Callcustomerservice('400-630-5888')">客服电话 400-630-5888</div>
  </div>
</template>

<script>
  import myPanelFunctionLink from '../subgroup/myPanelFunctionLink.vue'
  import myPanelFunctionOrder from '../subgroup/myPanelFunctionOrder.vue'
  export default {
    components:{
      'myPanelFunctionLink':myPanelFunctionLink,
      'myPanelFunctionOrder':myPanelFunctionOrder
    },
    data() {
      return {
        userinfo: {},
        nologin: true,
        loaded: false,
        invite_url: '',
        agency_url: '',
        agencyinvitestatus: 0
      }
    },
    created() {},
    mounted() {
      if (localStorage.getItem("token")) {
        this.getUerInfo();
        this.fxUser()
      } else {
        this.loaded = true
      }
    },
    activated() {
      // 有实名操作步骤，更新用户信息
      if (sessionStorage.getItem('realName') == 'yes') {
        sessionStorage.removeItem('realName')
        if (localStorage.getItem("token")) {
          this.getUerInfo();
        } else {
          this.loaded = true
        }
      }
    },
    methods: {
      toMyDetail(item) {
        // // console.log(item)
        // return
        this.$router.push({
          name: item
        })
      },
      tologin() {
        this.$router.push({
          name: "login",
        });
      },
      Callcustomerservice() {
        window.location.href = "tel:400-630-5888"
      },
      getUerInfo() {
        var $this = this
        this.$loading('加载中');
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.getInfo
        this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            console.log(result)
            if (result.data) {
              $this.$store.commit('updataMyInfo',result.data.user)
              $this.userinfo = Object.assign({}, result.data.user)
              setTimeout(function() {
                $this.$loading.close()
                $this.loaded = true
                $this.nologin = false
              }, 500)
            } else {
              $this.$store.commit('updataMyInfo',null)
              $this.$loading.close()
              $this.$toast(result.msg)
            }
          }).catch((error) => {
            console.warn(error)
            $this.$loading.close()
            // $this.$toast('error');
          })
      },
      fxUser() {
        var $this = this
        this.$loading('加载中');
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.getIsRetailUser
        this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // console.log(result)
            if (result.data) {
              $this.agencyinvitestatus = result.data.is_retail_user
              $this.agency_url = result.data.agency_url
              $this.invite_url = result.data.invite_url
            } else {
              this.$toast(result.msg)
            }
          }).catch((error) => {
            console.warn(error)
            // $this.$toast('error');
          })
      },
      bb_invite() {
        window.location.href = this.invite_url
      },
      bb_ang() {
        window.location.href = this.agency_url
      },
      toOrder(item) {
        var $this = this
        sessionStorage.setItem('order_list_status', item)
        setTimeout(function() {
          $this.$router.push({
            name: 'orderlist'
          })
        }, 300)
      },
      qimoChatClickyun() {
        window.qimoChatClick()
      },

    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;

  .bb_fx_tg {
    width: 148*@vm_base;
    height: 70*@vm_base;
    line-height: 70*@vm_base;
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 150*@vm_base;
    z-index: 999;
    background: rgba(0, 0, 0, 1);
    border-radius: 0px 100*@vm_base 100*@vm_base 0px;
    // opacity:0.19;
    font-size: 24*@vm_base;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    span {
      display: inline-block;
      height: 70*@vm_base;
      line-height: 70*@vm_base;
      float: left;
      margin-left: 25*@vm_base;
    }

    label {
      display: inline-block;
      width: 38*@vm_base;
      height: 70*@vm_base;
      float: left;
      background-image: url(../../assets/images/base/ang.png);
      background-size: 35*@vm_base auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .bb_fx_bf {
    width: 148*@vm_base;
    height: 70*@vm_base;
    position: absolute;
    top: 0;
    right: 0;
    width: 148*@vm_base;
    height: 70*@vm_base;
    margin-top: 150*@vm_base;
    z-index: 999;
    background: rgba(0, 0, 0, 1);
    border-radius: 100*@vm_base 0px 0px 100*@vm_base;
    // opacity:0.19;
    font-size: 24*@vm_base;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    span {
      display: inline-block;
      height: 70*@vm_base;
      line-height: 70*@vm_base;
      float: right;
      margin-right: 25*@vm_base;
    }

    label {
      display: inline-block;
      width: 35*@vm_base;
      height: 70*@vm_base;
      float: right;
      background-image: url(../../assets/images/base/inv.png);
      background-size: 32*@vm_base auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .uinfo {
    width: 100%;
    height: 700*@vm_base;
    position: relative;

    .uinfo_bg {
      width: 100%;
    }

    .userinfo_logotxtb {
      width: 280*@vm_base;
      height: 280*@vm_base;
      position: absolute;
      top: 0;
      left: 0;
      // width: 100%;
      z-index: 1;
      margin-left: calc(50% - 140*@vm_base);
      margin-top: 40*@vm_base;
    }

    .userinfo_logotxt {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 2;

      .userinfo_logotxti {
        width: 160*@vm_base;
        height: 160*@vm_base;
        border-radius: 50%;
        border: 3px solid #FFFFFF;
        margin: 0 auto;
        margin-top: 100*@vm_base;
      }

      .userinfo_logotxt1 {
        color: #FFFFFF;
        font-size: 48*@vm_base;
        text-align: center;
        margin-top: 22*@vm_base;
        // border: 1px solid red;
        display: flex;
        justify-content: center;
        align-items: center;
        .userinfo_logotxt1_female{
          width: 45*@vm_base;
          margin-left: 10*@vm_base;
        }
      }

      .userinfo_logotxt2 {
        font-size: 28*@vm_base;
        color: #666666;
        margin-top: 12*@vm_base;
        text-align: center;
      }

    }

    // .uinfo_order {
    //   position: absolute;
    //   bottom: 0;
    //   left: 0;
    //   width: 100%;
    //   margin-bottom: 8*@vm_base;
    // }
  }

  // .link {
  //   margin-top: 24*@vm_base;
  //   width: calc(100% - 64*@vm_base);
  //   margin-left: 32*@vm_base;
  //   padding: 0 32*@vm_base;
  //   overflow: auto;
  //   background: rgba(255, 255, 255, 1);
  //   box-shadow: 0px 4px 20px 0px rgba(238, 238, 238, 1);
  //   border-radius: 12px;
  //   li {
  //     // margin-bottom:40*@vm_base;
  //     height: 100*@vm_base;
  //     line-height: 100*@vm_base;
  //     font-size: 28*@vm_base;
  //     color: #333333;
  //     font-weight: 400;
  //   }
  //   .box {
  //     display: block;
  //     background: url(../../assets/images/base/icon_arrow.png) right center no-repeat;
  //     background-size: 24*@vm_base auto;
  //     overflow: auto;
  //     font-size: 28*@vm_base;
  //     line-height: 100*@vm_base;
  //     font-weight: 400;
  //     color: rgba(51, 51, 51, 1);
  //   }
  //   .icon {
  //     float: left;
  //     width: 60*@vm_base;
  //     height: 60*@vm_base;
  //     margin-right: 20*@vm_base;
  //     background-size: 60*@vm_base auto;
  //     background-repeat: no-repeat;
  //     background-position: center center;
  //   }
  //   .i1 {
  //     background-image: url(../../assets/images/base/icon_i1N.png);
  //     border: 1px solid #000000;
  //     border-radius: 50%;
  //   }
  //   .i2 {
  //     background-image: url(../../assets/images/base/icon_i2N.png);
  //     border: 1px solid #000000;
  //     border-radius: 50%;
  //   }
  //   .i3 {
  //     background-image: url(../../assets/images/base/icon_i3N.png);
  //     border: 1px solid #000000;
  //     border-radius: 50%;
  //   }
  //   .tel {
  //     float: right;
  //     line-height: 60*@vm_base;
  //     margin-right: 30*@vm_base;
  //     font-size: 24*@vm_base;
  //     font-weight: 300;
  //     color: rgba(153, 153, 153, 1);
  //   }
  // }

  .keftelout {
    color: #999999;
    height: 82*@vm_base;
    line-height: 82*@vm_base;
    text-align: center;
    font-size: 24*@vm_base;
  }

  // .myorder {
  //   margin-top: 16*@vm_base;
  //   padding: 0 30*@vm_base;
  //   clear: both;
  //   .myorder__box {
  //     width: 100%;
  //     padding: 0 30*@vm_base;
  //     background: rgba(255, 255, 255, 1);
  //     box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.08);
  //     border-radius: 20*@vm_base;
  //   }
  //   .myorder__box_title {
  //     padding: 32*@vm_base 0*@vm_base 52*@vm_base 0*@vm_base;
  //     font-size: 28*@vm_base;
  //     color: #282828;
  //     font-weight: 600;
  //     a {
  //       float: right;
  //       padding-right: 30*@vm_base;
  //       font-size: 25*@vm_base;
  //       font-weight: lighter;
  //       color: #999999;
  //       background: url(../../assets/images/base/icon_arrow.png) right center no-repeat;
  //       background-size: 18*@vm_base auto;
  //     }
  //   }
  //   .tit {
  //     padding: 32*@vm_base 0 50*@vm_base 0;
  //     border-bottom: 1px solid #eee;
  //     font-size: 28*@vm_base;
  //     height: 28*@vm_base;
  //     line-height: 28*@vm_base;
  //     font-weight: 400;
  //     color: #282828;
  //     font-weight: 600;
  //     a {
  //       float: right;
  //       padding-right: 30*@vm_base;
  //       font-size: 24*@vm_base;
  //       font-weight: 300;
  //       color: #999999;
  //       background: url(../../assets/images/base/icon_arrow.png) right center no-repeat;
  //       background-size: 16*@vm_base auto;
  //     }
  //   }
  //   ul {
  //     display: flex;
  //     overflow: auto;
  //     padding: 0 0 42*@vm_base 0;

  //     li {
  //       flex: 1;
  //       text-align: center;
  //       font-size: 24*@vm_base;
  //       font-weight: 400;
  //       color: rgba(51, 51, 51, 1);
  //       line-height: 33*@vm_base;

  //       p {
  //         color: #282828;
  //         font-weight: lighter;
  //       }
  //     }

  //     .icon {
  //       width: 52*@vm_base;
  //       height: 52*@vm_base;
  //       margin: 0 auto 10*@vm_base auto;
  //       // background-size:44*@vm_base auto auto;
  //       background-repeat: no-repeat;
  //       background-position: center center;
  //       background-size: 50*@vm_base auto;
  //     }

  //     .i1 {
  //       background-image: url(../../assets/images/base/comparead.png);
  //     }

  //     .i2 {
  //       background-image: url(../../assets/images/base/comphalf.png);
  //     }

  //     .i3 {
  //       background-image: url(../../assets/images/base/compend.png);
  //     }
  //   }
  // }

  .userinfo_mologin {
    color: #FFFFFF;
    font-size: 48*@vm_base;
    font-weight: 500;
    margin-top: 42*@vm_base;
    width: 250*@vm_base;
    margin-left: calc(50% - 125*@vm_base);
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/my/my.vue